/**
 * 和家亲SDK封装 - 直接引入SDK文件
 */
import store from '@/store'
/* eslint-disable */
// 直接引入SDK文件，并忽略ESLint检查
import hejiaqinSDK from '../../public/hejiaqin/hejiaqinSdk.2.0.0.js'
/* eslint-enable */
import { getThirdAccessToken, postThirdOAuth, postThirdLogin } from '@/api'

// 引入sensors
var sensors = require('sa-sdk-javascript')

// 初始化和家亲SDK参数
const HJQ_SDK_CONFIG = {
  appId: '1212636290259116032',
  signature: ''
}

/**
 * 获取匿名用户ID
 * @returns {string} 匿名用户ID
 */
const getAnonymousId = () => {
  try {
    // 确保sensors已经初始化
    if (typeof sensors !== 'undefined' && sensors.store) {
      return sensors.store.getFirstId() || sensors.store.getDistinctId() || ""
    }
    return ""
  } catch (error) {
    console.warn('获取匿名用户ID失败:', error)
    return ""
  }
}
/**
 * 初始化和家亲SDK
 * @returns {Promise} SDK初始化后的Promise，失败时不会阻断后续流程
 */
export const initHejiaqinSDK = async () => {
  // 检查SDK是否正确加载
  if (!hejiaqinSDK || typeof hejiaqinSDK.init !== 'function') {
    console.warn('hejiaqinSDK对象未正确加载或init方法不存在')
    return { success: false, error: 'SDK未正确加载' }
  }

  try {
    // 获取匿名用户ID
    const anonymous_id = getAnonymousId()
    
    // 1. 获取第三方访问令牌
    const tokenRes = await getThirdAccessToken({}, {channel:'hjq-komect'})
    if (tokenRes.status !== 0 || !tokenRes.data) {
      console.warn('获取访问令牌失败:', tokenRes.message)
      return { success: false, error: tokenRes.message || '获取访问令牌失败' }
    }

    // 2. 更新签名并初始化SDK
    HJQ_SDK_CONFIG.signature = tokenRes.data
    await hejiaqinSDK.init({
      appId: HJQ_SDK_CONFIG.appId,
      signature: HJQ_SDK_CONFIG.signature
    })

    // 3. 获取用户token
    const userToken = await hejiaqinSDK.getInfo('token')

    // 4. 第三方OAuth认证
    const oauthRes = await postThirdOAuth({
      login_code: userToken,
      platform: 22,
      anonymousId: anonymous_id
    }, {channel:'hjq-komect'})
    
    if (oauthRes.status !== 0) {
      console.warn('OAuth认证失败:', oauthRes.message)
      return { success: false, error: oauthRes.message || 'OAuth认证失败' }
    }

    // 5. 第三方登录
    const loginRes = await postThirdLogin({
      third_session: oauthRes.data.third_session,
      platform: 22,
      anonymousId: anonymous_id
    }, {channel:'hjq-komect'})

    if (loginRes.status === 0) {
      console.log('和家亲登录成功:', loginRes)
      store.dispatch('getUserInfo')
      return { success: true, data: loginRes }
    } else {
      console.warn('登录失败:', loginRes.message)
      return { success: false, error: loginRes.message || '登录失败' }
    }

  } catch (error) {
    console.error('和家亲SDK初始化异常:', error)
    return { success: false, error: error.message || '初始化异常' }
  }
}

/**
 * 获取SDK实例
 */
export default hejiaqinSDK